import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../styles/diario.scss'

const Documento = (props) => {

    function renderButtons(props) {
        const buttons = [];

        if (props.doc.anexos) {
            props.doc.anexos.forEach((anexo, index) => {
                buttons.push(
                    <Fragment key={`anexo-${index}`}>
                        <a href={anexo.arquivo} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">{anexo.nomeAnexo}</Button>
                        </a>
                        <br />
                        <br />
                    </Fragment>
                );
            });
        }
        return buttons;
    }

    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                    <Card.Header><h5>{props.doc.categoria} {props.doc.referencia ? <span>referente a {props.doc.referencia}</span> : null} de {props.doc.ano}</h5></Card.Header>
                    <Card.Body>
                        {renderButtons(props)}
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Documento;